import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { UserService } from '../_services/user.service';
import { User } from '../_models/user';
import { RestError } from '../_models/resterror';

@Component({
  moduleId: module.id,
  templateUrl: 'my-account.component.html',
  styleUrls: ['my-account.component.css']
})

export class MyAccountComponent implements OnInit {
  error = false;
  loading = false;
  success = false;
  model: User;

  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService
  ){}

  ngOnInit() {
    this.model = this.authenticationService.currentUser;
  }

  onError(err) {
    this.loading = false;
    this.error = true;
  }

  submit() {
    this.error = null;
    this.loading = true;
    this.success = false;

    this.userService.editUser(this.model)
      .then(user => {
        this.success = true;
        this.loading = false;
        this.model = user;
      })
      .catch(err => {
        this.error = JSON.parse(err._body).error;
        this.loading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/my-account/my-account.component.ts